import comp from "./CaptureVideo";
export default comp;
